import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearTipoDocumento } from "../hooks/use-tipo-documento-mutations";

/**
 * Formulario de creación de tipo de documento · solo el nombre (se guarda en
 * MAYÚSCULAS, único). Nace activo y disponible de inmediato en el picker.
 */
export function TipoDocumentoCrearForm({ onSalir }: { onSalir: () => void }) {
  const [nombre, setNombre] = useState("");
  const crear = useCrearTipoDocumento({ onCreado: onSalir });

  const submit = () => {
    if (!nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "El nombre del tipo es obligatorio." });
      return;
    }
    crear.mutate({ nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nuevo tipo de documento"
      descripcion="Se guarda en mayúsculas y debe ser único · queda disponible de inmediato para clasificar documentos adicionales."
      cols={2}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input
        label="Nombre"
        placeholder="EJ. CONSTANCIA DE SITUACIÓN FISCAL"
        value={nombre}
        onChange={(e) => setNombre(e.currentTarget.value.toUpperCase())}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        maxLength={120}
        required
        wrapperClassName="max-w-130"
      />
    </CrearEntidadForm>
  );
}
